import Loadable from './Loadable';

const PATH_PREFIX = '/subdirectory/:companyID';

export default [
  {
    name: 'subdirectory.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/dashboard')),
  },
  {
    name: 'subdirectory.list',
    path: `${PATH_PREFIX}/list`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/list')),
  },
  {
    name: 'subdirectory.detail',
    path: `${PATH_PREFIX}/:docID/detail`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/detail')),
  },
  {
    name: 'subdirectory.theme',
    path: `${PATH_PREFIX}/:docID/theme`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/theme')),
  },
  {
    name: 'subdirectory.logo',
    path: `${PATH_PREFIX}/:docID/logo`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/logo')),
  },
  {
    name: 'subdirectory.banner',
    path: `${PATH_PREFIX}/:docID/banner`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/banner/list')),
  },
  {
    name: 'subdirectory.banner.detail',
    path: `${PATH_PREFIX}/:docID/banner/:bannerID`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/banner/detail')),
  },
  {
    name: 'subdirectory.pageSetting.home.display',
    path: `${PATH_PREFIX}/:docID/page/setting/home/display`,
    exact: true,
    component: Loadable(
      import('../ui/apps/subdirectory/pageSetting/HomePage/HomePageDisplay')
    ),
  },
  {
    name: 'subdirectory.pageSetting.home.categories',
    path: `${PATH_PREFIX}/:docID/page/setting/home/categories`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/subdirectory/pageSetting/HomePage/HomePageCategory/list'
      )
    ),
  },
  {
    name: 'subdirectory.pageSetting.home.category',
    path: `${PATH_PREFIX}/:docID/page/setting/home/categories/:subdirectoryKeywordGroupID`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/subdirectory/pageSetting/HomePage/HomePageCategory/detail'
      )
    ),
  },
  {
    name: 'subdirectory.pageSetting.pages',
    path: `${PATH_PREFIX}/:docID/page/setting/pages`,
    exact: true,
    component: Loadable(
      import('../ui/apps/subdirectory/pageSetting/pages/list')
    ),
  },
  {
    name: 'subdirectory.pageSetting.pages.detail',
    path: `${PATH_PREFIX}/:docID/page/setting/pages/:slug`,
    exact: true,
    component: Loadable(
      import('../ui/apps/subdirectory/pageSetting/pages/detail')
    ),
  },
  {
    name: 'subdirectory.announces',
    path: `${PATH_PREFIX}/:docID/announces`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/announce/list')),
  },
  {
    name: 'subdirectory.announces.detail',
    path: `${PATH_PREFIX}/:docID/announces/:announceID`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/announce/detail')),
  },
  {
    name: 'subdirectory.siteSetting',
    path: `${PATH_PREFIX}/:docID/site/setting`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/siteSetting')),
  },
  {
    name: 'subdirectory.company',
    path: `${PATH_PREFIX}/:docID/company`,
    exact: true,
    component: Loadable(import('../ui/apps/subdirectory/company')),
  },
];
